// urls that are not used by the DAO, those are kept within the DAO files
export const SLOW_REQUEST_THRESHOLD = 4000;
export const CONFIG_URL = '/config.json';
export const SUPPORT_EMAIL = 'support@fastmodelsports.com';
export const SUPPORT_URL =
  'http://support.fastmodelsports.com/support/solutions/';
export const SUPPORT_LINK =
  'https://support.hudl.com/s/contactsupport?language=en_US';
